import MComponent from '../Toolkit/Components/Component';
import {withMsal, WithMsalProps} from '@azure/msal-react';
import WithRouterProps from '../Toolkit/WithRouterProps';
import MPage, {MPageProps} from '../Toolkit/Components/Shell/Page';
import MTable, {MTableProps} from '../Toolkit/Components/Controls/Table';
import NSwagAdapter from '../Toolkit/Api/NSwagAdapter';
import MNSwagClientConfiguration from '../Toolkit/Api/NSwagClientConfiguration';
import SafeDigAccessTokenProvider from '../Api/SafeDigAccessTokenProvider';
import React, {createRef, ReactElement, RefObject} from 'react';
import WithRouter from '../Toolkit/WithRouter';
import MToolbar from '../Toolkit/Components/Controls/Toolbar';
import MButton from '../Toolkit/Components/Controls/Button';
import {MNewIconName, MOpenIconName} from '../Toolkit/Icons';
import MSpacer from '../Toolkit/Components/Controls/Spacer';
import {DataTable} from 'primereact/datatable';
import {FilterMatchMode} from 'primereact/api';
import {Column} from 'primereact/column';
import EnumContext from '../Context/enum-context';
import {Contact, ContactReplyMulti} from '../Api/ContactTypes';
import {ContactClient} from '../Api/ContactClients';

type ContactRow = {
    contact: Contact;
}

type Props = WithMsalProps & WithRouterProps & {};

/** */
type State = {
    page: MPageProps;
    table: MTableProps<ContactRow>;
    selectedRow?: ContactRow;
}

class ListContactsPage extends MComponent<Props, State> {
    static contextType = EnumContext;
    context!: React.ContextType<typeof EnumContext>;

    private readonly m_contactClient: NSwagAdapter<ContactClient>;
    private readonly m_datatableRef: RefObject<DataTable>;

    public constructor(props: Props) {
        super(props);

        this.bindMethods();

        this.m_contactClient = new NSwagAdapter<ContactClient>(new ContactClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_datatableRef = createRef<DataTable>();

        this.initializeState();
    }

    private bindMethods(): void {
        this.new_Click = this.new_Click.bind(this);
        this.open_Click = this.open_Click.bind(this);
        this.notices_Click = this.notices_Click.bind(this);
        this.table_onSelectionChange = this.table_onSelectionChange.bind(this);
        this.page_onLoadData = this.page_onLoadData.bind(this);
        this.isOpenButtonDisabled = this.isOpenButtonDisabled.bind(this);
        this.getToolbarTemplate = this.getToolbarTemplate.bind(this);
    }

    private initializeState(): void {
//  Page
        const page: MPageProps = {
            locked: false
        };

        //  Table
        const table: MTableProps<ContactRow> = {
            exportName: 'Contacts',
            rowData: [],
            filters: {
                'contact.contactName': {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS
                },
                'contact.contactEmail': {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS
                }
            }
        };

        this.state = {
            page: page,
            table: table,
            selectedRow: undefined
        };
    }

    private isOpenButtonDisabled(): boolean {
        return this.state.selectedRow === undefined;
    }

    private new_Click(): void {
        this.props.navigate('/contacts/create');
    }

    private open_Click(): void {
        this.props.navigate(`/contacts/${this.state.selectedRow!.contact.id}`);
    }

    private notices_Click(): void {
        this.props.navigate(`/notices`);
    }

    private table_onSelectionChange(selection: ContactRow | ContactRow[] | undefined): void {

        this.safeSetState((draft: State) =>
            draft.selectedRow = selection as ContactRow | undefined);

    }

    private async page_onLoadData(): Promise<void> {
        const listResult = await this.m_contactClient.callWithReply(
            ContactReplyMulti, (client) => client.listContacts()
        );

        listResult.throwIfFailed();

        this.safeSetState((draft: State) => {
            draft.table.rowData = listResult.reply!.contacts
                                                   .map((w: Contact) => {
                                                       return {contact: w} as ContactRow;
                                                   });
        });
    }

    private getToolbarTemplate(): ReactElement<MToolbar> {
        return (
            <MToolbar>
                <MButton label="Add"
                         color="success"
                         icon={MNewIconName}
                         iconOnly={false}
                         disabled={false}
                         onClick={this.new_Click}/>
                <MSpacer/>
                <MButton label="Open"
                         icon={MOpenIconName}
                         iconOnly={false}
                         disabled={this.isOpenButtonDisabled}
                         onClick={this.open_Click}/>
                <MSpacer/>
                <MButton label="Notices"
                         color="help"
                         icon={'pi pi-tag'}
                         iconOnly={false}
                         disabled={false}
                         onClick={this.notices_Click}/>
            </MToolbar>
        );
    }

    public render(): ReactElement {
        return (
            <MPage title="Contacts"
                   locked={this.state.page.locked}
                   toolbar={this.getToolbarTemplate()}
                   onLoadData={this.page_onLoadData}>

                <MTable innerRef={this.m_datatableRef}
                        rowKey="contact.id"
                        rowData={this.state.table.rowData}
                        filters={this.state.table.filters}
                        onSelectionChange={this.table_onSelectionChange}
                        sortMode={'multiple'}
                        multiSortMeta={[{field: 'contact.id', order: 1}]}>

                    <Column field="contact.contactName"
                            header="Contact Name"
                            filter={true}
                            sortable={true}
                            style={{width: '30%'}}/>
                    <Column field="contact.contactEmail"
                            header="Contact Email"
                            filter={true}
                            sortable={true}
                            style={{width: '70%'}}/>
                </MTable>
            </MPage>
        );
    }
}

export default withMsal(WithRouter(ListContactsPage));


